'use strict';

function updateMaxValue() {
  const maxInput = document.querySelector('input.calorie_max');
  const minInput = document.querySelector('input.calorie_min');
  if (!maxInput || !minInput) return;
  const max = Number(maxInput.value);
  const min = Number(minInput.value);
  if (max < min) maxInput.value = String(min);
}

function updateMinValue() {
  const minInput = document.querySelector('input.calorie_min');
  const maxInput = document.querySelector('input.calorie_max');
  if (!minInput || !maxInput) return;
  const min = Number(minInput.value);
  const max = Number(maxInput.value);
  if (min > max) minInput.value = String(max);
}

const init = () => {
  updateMaxValue();
  updateMinValue();

  const maxInput = document.querySelector('input.calorie_max');
  const minInput = document.querySelector('input.calorie_min');

  if (maxInput) {
    maxInput.removeEventListener('change', updateMinValue, true);
    maxInput.addEventListener('change', updateMinValue, true);
  }

  if (minInput) {
    minInput.removeEventListener('change', updateMaxValue, true);
    minInput.addEventListener('change', updateMaxValue, true);
  }
};

document.addEventListener('turbo:load', init, true);
document.addEventListener('DOMContentLoaded', init, true);
